import * as React from 'react';
import Box from '@mui/material/Box';
import { useEffect } from 'react';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import { getApi } from 'views/services/api';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import EditIcon from '@mui/icons-material/Edit';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import LockIcon from '@mui/icons-material/Lock';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import EditAdmin from './Components/EditAdmin';
import ChangePassword from './Components/ChangePassword';
import { useTranslation } from 'react-i18next';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(2),
  textAlign: 'left',
  color: theme.palette.text.secondary
}));

export default function AdminProfile() {
  const { t } = useTranslation();
  const [openEdit, setOpenEdit] = useState(false);
  const [openChangePassword, setOpenChangePassword] = useState(false);
  const [hotelData, setHotelData] = useState([]);
  const navigate = useNavigate();

  const handleOpenEditAdmin = () => setOpenEdit(true);
  const handleCloseEditAdminDialog = () => setOpenEdit(false);
  
  const handleOpenChangePassword = () => setOpenChangePassword(true);
  const handleCloseChangePassword = () => setOpenChangePassword(false);

  // Fetching admin data
  const fetchAdminData = async () => {
    const hotelData = JSON.parse(localStorage.getItem('hotelData'));
    console.log("hotelData =========> ", hotelData);
    try {
      const response = await getApi(`api/hotel/view/${hotelData?.hotelId}`);
      setHotelData(response?.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchAdminData();
  }, [openEdit]);

  return (
    <>
      <EditAdmin open={openEdit} handleClose={handleCloseEditAdminDialog} data={hotelData} />
      <ChangePassword 
        open={openChangePassword} 
        handleClose={handleCloseChangePassword} 
        email={hotelData?.email}
      />
      <Box sx={{ width: '100%', typography: 'body1' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h2">{`${hotelData?.name} ${t('Information')}`}</Typography>
          <div>
            <Button
              variant="outlined"
              startIcon={<ArrowBackIcon />}
              sx={{ marginLeft: 2, color: '#673ab7', borderColor: '#673ab7', marginBottom: '12px' }}
              onClick={() => navigate(-1)}
            >
              {t('Back')}
            </Button>
          </div>
        </Box>

        <Grid>
          <Item>
            <Typography variant="h4">{t('View Details')}</Typography>
            <hr />

            <Grid container spacing={2} sx={{ justifyContent: 'between', alignItems: 'center', marginTop: '1px' }}>
              <Grid item xs={6} md={6}>
                <Typography variant="h5">{t('Name')}</Typography>
                <Typography style={{ color: 'black' }}>{`${hotelData?.name}`}</Typography>
              </Grid>
              <Grid item xs={6} md={6}>
                <Typography variant="h5">{t('Email')}</Typography>
                <Typography style={{ color: 'black' }}>{hotelData?.email}</Typography>
              </Grid>
            </Grid>
            <Grid container spacing={2} sx={{ justifyContent: 'between', alignItems: 'center', marginTop: '1px' }}>
              <Grid item xs={6} md={6}>
                <Typography variant="h5">{t('Phone Number')}</Typography>
                <Typography style={{ color: 'black' }}>{hotelData?.contact}</Typography>
              </Grid>
            </Grid>
            
            {/* Action Buttons */}
            <Grid container spacing={2} sx={{ justifyContent: 'flex-end', alignItems: 'center', marginTop: '20px' }}>
              <Grid item>
                <Button
                  startIcon={<LockIcon />}
                  variant="contained"
                  onClick={handleOpenChangePassword}
                  sx={{ 
                    backgroundColor: '#673ab7',
                    '&:hover': {
                      backgroundColor: '#5e35b1'
                    }
                  }}
                >
                  {t('Change Password')}
                </Button>
              </Grid>
            </Grid>
          </Item>
        </Grid>

        {/* <Grid container spacing={2} sx={{ justifyContent: 'between', alignItems: 'center', marginTop: '1px' }}>
          <Grid item xs={12} md={12} sx={{ display: 'flex', justifyContent: 'end', gap: 3 }}>
            <Button
              startIcon={<EditIcon />}
              variant="outlined"
              sx={{ marginLeft: 2, color: '#673ab7', borderColor: '#673ab7' }}
              onClick={handleOpenEditAdmin}
            >
              {t('Edit')}
            </Button>
          </Grid>
        </Grid> */}
      </Box>
    </>
  );
}
